<template>
    <div>
        <b-modal
                id="set-currency-popup"
                ref="modal"
                :title="title"
                size="sm"
                hide-footer
                modal-class="hide-footer"
                no-close-on-backdrop
                no-close-on-esc
                :hide-header-close="loading"
                @hidden="onHidden"
        >
            <b-form
                    @submit.stop.prevent="onSubmit()"
                    @reset.stop.prevent="onHidden"
            >
                <div class="row custom-model-form">

                    <div class="col-md-12">
                        <b-form-group
                                id="input-group-4"
                                label="Currency Symbol"
                                label-for="currency"
                        >
                            <b-form-input
                                    id="currency"
                                    v-model="currency"
                                    v-validate="{
                                    required: true,
                                }"
                                    name="currency"
                                    :class="{
                                    'is-invalid': errors.has('currency'),
                                }"
                                    autocomplete="no"
                                    placeholder="Enter symbol"
                            ></b-form-input>
                        </b-form-group>
                    </div>

                </div>
                <div class="col-md-12 action-buttons">
                    <base-button
                            :btn-label="buttonLabel"
                            btn-type="submit"
                            btn-variant="primary"
                            :class="loading ? 'disabled' : ''"
                    ></base-button>
                    <base-button
                            btn-label="Cancel"
                            btn-type="reset"
                            :disabled="loading"
                            btn-variant="link"
                    ></base-button>
                </div>
                <base-toast></base-toast>
            </b-form>
        </b-modal>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import axios from 'axios'
    export default {
        components: {
        },

        /*
        |--------------------------------------------------------------------------
        | Component > props
        |--------------------------------------------------------------------------
        */
        props: {
            dataSegmentId:{type:String},
            currency:{type:String},
        }, // End of Component > props
        /*
        |--------------------------------------------------------------------------
        | Component > data
        |--------------------------------------------------------------------------
        */
        watch: {
            currency(value)
            {

            }
        },

        /*
        |--------------------------------------------------------------------------
        | Component > computed
        |--------------------------------------------------------------------------
        */
        computed: {
            ...mapGetters(['loading', 'selectedItem', 'hidePopup']),
            title() {
                return this.selectedItem ? 'Modify' : 'Set Currency Symbol'
            }, // End of title() method

            buttonLabel() {
                return this.selectedItem ? 'Update' : 'Set'
            },
        }, // End of Component > computed
        /*
        |--------------------------------------------------------------------------
        | Component > watch
        |--------------------------------------------------------------------------
        */

        mounted() {
            // get datasegment and roles options list
            // this.getRolesList();
        },
        methods: {

            async onSubmit() {
                const result = await this.$validator.validateAll()
                if (result) {
                    try {
                        this.$store.commit('setLoading', true)

                        let dataObj = {
                            dataSegmentId:this.dataSegmentId,
                            currency : this.currency
                        }
                        const { data } = await axios({
                            method: 'post',
                            url: `${process.env.VUE_APP_API_URL}configurations/setCurrency`,
                            data: dataObj,

                        })

                        if(data.message)
                        {
                            this.$store.commit('setSuccess', data.message)
                        }
                        else
                        {
                            console.log('I am in error');
                            this.$store.commit('setError', 'Something went wrong.')
                        }
                        this.$store.commit('setLoading', false)
                        this.$refs.modal.hide()

                    } catch (error) {
                        this.$store.commit('setLoading', false)
                        console.log(error, 'There is an error on submit')
                    }
                } else {
                    this.$store.commit('setLoading', false)
                    this.$store.commit('setError', this.errors.all()[0])
                }
            },
            /**
             * Handle when the modal is closed
             *
             * @return {void}
             */
            onHidden() {
                // clear the selected item
                this.$store.commit('clearItem')
                this.$validator.reset()
                this.$refs.modal.hide()
            }, // End of onHidden() method

        },
    }
</script>
